export const track = (
  event: string,
  properties?: any,
  options?: any,
  callback?: any,
) => {
  console.log(
    `To be implemented Event: ${event}`,
    properties,
    options,
    callback,
  );
};

export const page = (
  category?: string,
  name?: string,
  properties?: any,
  options?: any,
  callback?: any,
) => {
  console.log(
    `To be implemented Page: ${category} - ${name}`,
    properties,
    options,
    callback,
  );
};

export const identify = (
  userId?: string,
  traits?: any,
  options?: any,
  callback?: any,
) => {
  console.log(
    `To be implemented Identify: ${userId}`,
    traits,
    options,
    callback,
  );
};

export const init = (cfg: any, debug?: any): Promise<void> | undefined => {
  console.log('To be implemented Init:', cfg, debug);
  return Promise.resolve();
};

export const reset = (flag?: any) => {
  console.log('To be implemented Reset:', flag);
};
